/* eslint-disable no-unused-vars */
export class ApiServiceManager {
  getUrl = () => this.path;
  constructor(
    public readonly path: string,
    public readonly method: "POST" | "GET" | "PUT" | "DELETE" | "PATCH",
    public tokenProvider?: () => Promise<string | null>,
    public tokenUpdater?: (token: string) => any
  ) {}
}
export const fetchRequest: <TInput, TOutput>(
  apiServiceManager: ApiServiceManager,
  inputData?: any,
  headers?: any
) => Promise<TOutput> = async <TInput, TOutput>(
  apiServiceManager: ApiServiceManager,
  inputData: any,
  headers?: any
) => {
  const url = apiServiceManager.getUrl();
  const method = apiServiceManager.method;
  let defaultHeaders = new Headers();
  const tokenUpdater = apiServiceManager.tokenUpdater;
  const tokenProvider = apiServiceManager.tokenProvider;
  const token = tokenProvider && (await tokenProvider());
  defaultHeaders.append("Content-Type", "application/json;");
  if (token) {
    defaultHeaders.append("authorization", "Bearer " + token);
  }
  if (headers) {
    defaultHeaders = { ...defaultHeaders, ...headers };
  }
  let body: string | FormData | undefined =
    inputData && JSON.stringify(inputData);
  if (inputData instanceof FormData) {
    body = inputData;
  }

  return new Promise((resolve, reject) => {
    fetch(url, { headers: defaultHeaders, body, method })
      .then(async (response) => {
        const text = await response.text();
        const json = text ? JSON.parse(text) : {};
        if (json.successful === false || json.error) reject(json);
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
